import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["message"]

  connect() {
    // Add initial hidden state
    this.messageTarget.classList.add("transform", "scale-95", "opacity-0")

    // Force a reflow
    void this.messageTarget.offsetWidth

    // Add transition classes
    this.messageTarget.classList.add("transition-all", "duration-300", "ease-out")

    // Animate in
    setTimeout(() => {
      this.messageTarget.classList.remove("scale-95", "opacity-0")
      this.messageTarget.classList.add("scale-100", "opacity-100")
    }, 50)

    this.addCloseButton()
  }

  addCloseButton() {
    const closeButton = document.createElement("button")
    closeButton.innerHTML = `
      <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
      </svg>
    `
    closeButton.classList.add(
      "flash-close-button",
      "absolute",
      "top-3",
      "right-3",
      "text-current",
      "opacity-60",
      "hover:opacity-100",
      "transition-colors",
      "duration-200"
    )
    closeButton.addEventListener("click", () => this.close())
    this.messageTarget.appendChild(closeButton)
  }



  close() {
    this.messageTarget.classList.add("transform", "scale-95", "opacity-0")
    setTimeout(() => {
      if (this.messageTarget.parentNode) {
        this.messageTarget.remove()
      }
    }, 300)
  }
}
